module.exports = __webpack_public_path__ + "static/media/googlebrandsb6cd1eaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/googlebrands.svg
// module id = 1526
// module chunks = 0